import { images } from "../../assets/images";
const {
    Documents,
    HomeIcon,
    Bell,
    Checkin,
    Agreement,
    Rewards,
    Profile,
    Receipt,
    ReportIssue,
    Rupee,
  } = images;
export const tenantScreenData = [
    {
      name: "Onboarding",
      desc: "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
      img: Profile,
    },
    {
      name: "Digital KYC",
      desc: "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
      img: Documents,
    },
    {
      name: "Digital rental agreement",
      img: Agreement,

      desc: "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
    },
    {
      name: "Online Payments",
      img: Rupee,
      desc: "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
    },
    {
      name: "Automated rent reminders",
      img: Bell,
      desc: "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
    },
    {
      name: "Digital check-in",
      img: Checkin,

      desc: "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
    },
    {
      name: "Online receipt",
      img: Receipt,

      desc: "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
    },
    {
      name: "Property booking",
      img: HomeIcon,

      desc: "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
    },
    {
      name: "Online queries and complaints",
      img: ReportIssue,

      desc: "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
    },
    {
      name: "Exciting offers and rewards",
      img: Rewards,

      desc: "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
    },
  ];export const myList = [
    {
        ListNo : 1, Title:"Download the App", Desc:"Sit mauris habitasse blandit dictum dui aliquam quam quam scelerisque. Tempor ut hac sagittis feugiat."
    },
    {
        ListNo : 2, Title:"Find Properties", Desc:"Sit mauris habitasse blandit dictum dui aliquam quam quam scelerisque. Tempor ut hac sagittis feugiat."
    },
    {
        ListNo : 3, Title:"Connect with owners", Desc:"Sit mauris habitasse blandit dictum dui aliquam quam quam scelerisque. Tempor ut hac sagittis feugiat."
    },
    {
        ListNo : 4, Title:"Onboard yourself digitally ", Desc:"Sit mauris habitasse blandit dictum dui aliquam quam quam scelerisque. Tempor ut hac sagittis feugiat."
    },
    {
        ListNo : 5, Title:"Experience a digital stay", Desc:"Sit mauris habitasse blandit dictum dui aliquam quam quam scelerisque. Tempor ut hac sagittis feugiat."
    },

]